module.exports = __webpack_public_path__ + "static/media/down-purple-dropdown.91811095.svg";